import { Config } from "../../../configurations/config"

export const ItemRequisitionAPI = {
  //-----------------------------------Supervisor Item Requisition Layout ------------------------//
  GetDefaultItemRequisitionRequests: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  GetItemRequisitionStatusTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/ItemRequisitionStatusTypes`,
  GetItemRequisitionRequestDetailById: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  GetSupervisorApprovals: `${Config.server_url}${Config.api_prefix}/ItemRequisition/SupervisorApprovalTypes`,
  GetPaidByTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetPaidByTypes`,
  PatchApproveRejectRequest: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  GetItemRequisitionClasses: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Class`,
  GetItemRequisitionCategories: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Category`,
  GetActiveClasses: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Class/Active`,
  GetItemRequisitionVendor: `${ Config.server_url }${ Config.api_prefix }/ItemRequisition/Vendor`,

  //-----------------------------------Kashif Flows Layout ------------------------//
  GetRequestTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetRequestTypes`,
  GetCategories: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetCategories`,
  GetAdminSupportApprovalTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetAdminSupportApprovalTypes`,
  GetVendorByCategoryId: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Category`,
}
